export default __webpack_public_path__ + "static/yahoooffice-2c94c732d87072155445c9466d5a1918.png";